import { v4 as ukey } from "uuid";
import ServiceItem from "./ServiceItem/ServiceItem";
import { ourServicies } from "./ServiceItem/AllServiceData.js"
import "./style.css"


const OurServices = (props) => {
    return <>
        <div className="about-services">
            <p className="services-header">Наши Сервисы</p>
            <div className="services-container">
                {
                    ourServicies.map(item => {
                        return (
                            <div className={"service-item item-" + item.id} key={ukey()}>
                                <ServiceItem serviceData={item} />
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </>
}

export default OurServices;